import type { TabParamList } from '../../navigation/types';

/** Tab bar initial route after auth / cold start — keep free of screen imports. */
export const MAIN_TAB_INITIAL_ROUTE: keyof TabParamList = 'Dashboard';
